import classNames from 'classnames'
import type {ReactNode} from 'react'
import {memo} from 'react'

import styles from './ParametersRow.css'

interface Props {
  className?: string
  role: string
  contentClassName?: string
  nameClassName?: string
  valueClassName?: string
  name: ReactNode
  value: ReactNode
}

function ParametersRowComponent(props: Props) {
  return (
    <div role={props.role} className={classNames(styles.row, props.className)}>
      <div className={classNames(styles.content, props.contentClassName)}>
        <div className={classNames(styles.columnName, styles.column, props.nameClassName)}>
          {props.name}
        </div>
        <div className={classNames(styles.columnValue, styles.column, props.valueClassName)}>
          {props.value}
        </div>
      </div>
    </div>
  )
}

export const ParametersRow = memo<Props>(ParametersRowComponent)
